import createPlotlyComponent from 'react-plotly.js/factory';
import * as Plotly from 'plotly.js';
import * as d3 from 'd3';
import {
    localePtBr,
    serieCampanhaColors2,
    countingClassesColors,
    countingClassesColors2,
    tipoLimiarColorsForPlot,
    statusOrder,
    statusOrderTranslated,
    amostraTipos,
    coresDagradeStatusRanges,
    coresCategoricalStatusRanges
} from './Settings';

function getPlotlyPlot() {
    Plotly.register(localePtBr);
    Plotly.setPlotConfig({ locale: 'pt-BR' });
    return createPlotlyComponent(Plotly);
}

function serieCampanhaColor(idSerie) {
    const cor = serieCampanhaColors2[idSerie];
    if (cor === undefined) { throw new Error('idSerie não encontrada: ' + idSerie); }
    return cor;
}

function getCountingColor(status) {
    let cor = countingClassesColors[status];
    if (cor === undefined) {
        cor = countingClassesColors2[status];
        if (cor === undefined) { throw new Error('Status não encontrado: ' + status); }
    }
    return cor;
}

function getCountingColorWithValue(status, values, value) {
    if (status === 'DENTRO') return getCountingColor(status);
    else return getCategoricalColorFunction(status, values)(value);
}

function getColorForLimiar(tipoLimiar, booleanInferiorSuperior) {
    const colorKey = tipoLimiar + "_" + booleanInferiorSuperior.toString();
    const color = tipoLimiarColorsForPlot[colorKey];
    if (typeof color !== 'undefined') return color;
    else return null;
}

function convertStatusName(name) {
    const slices = name.split(" ");
    let newName;
    if (slices.length > 1) newName = statusOrderTranslated[statusOrder.indexOf(slices[0])] + " (" + slices[2] + ")";
    else newName = statusOrderTranslated[statusOrder.indexOf(slices[0])];
    return newName
}

function getAmostraTipos() {
    return amostraTipos.map(amostra => amostra.ncode);
}

function getNomeLimiarSerieOuAmostraParaGraficoDeDistribuicao(limiar) {
    let nome = null;
    if (limiar.serieAnalise !== undefined && limiar.serieAnalise !== null) nome = limiar.nomeTipo + " | " + limiar.serieAnalise.nome;
    else {
        amostraTipos.forEach(e => {
            if (e.ncode === limiar.idTipoAmostra) nome = limiar.nomeCompleto;
        });
    }
    return nome.replace('Limite de quantificação', 'LQ');
}

function getAxisType(data) {
    const sortingFunction = function sortNumber(a, b) { return a - b; };
    let lesserValues = [];
    data.series.forEach(el => {
        el.data.sort(sortingFunction);
        lesserValues.push(el.data[0]);
    });
    let type = 'linear';
    if (typeof lesserValues !== 'undefined' && lesserValues.length > 0) {
        lesserValues.sort(sortingFunction);
    }
    if (lesserValues[0] > 0) type = 'log';
    return type;
}

function getDegradeColorFunction(status, values) {
    const range = coresDagradeStatusRanges[status];
    const domain = [Math.min(...values), Math.max(...values)];
    const scale = d3.scaleLinear().domain(domain).range(range);
    return scale;
}

function getCategoricalColorFunction(status, values) {
    const range = coresCategoricalStatusRanges[status];
    const domain = [Math.min(...values), Math.max(...values)];
    const scale = d3.scaleOrdinal().domain(domain).range(range);
    return scale;
}

function getColorsByStatusValues(values, status) {
    const f = getDegradeColorFunction(values, status);
    let colors = [];
    values.forEach(e => {
        colors.push(f(e));
    });
    return colors;
}

export {
    getPlotlyPlot,
    getCountingColor,
    getCountingColorWithValue,
    serieCampanhaColor,
    statusOrder,
    statusOrderTranslated,
    getColorForLimiar,
    convertStatusName,
    getAmostraTipos,
    getNomeLimiarSerieOuAmostraParaGraficoDeDistribuicao,
    getAxisType,
    getColorsByStatusValues
};